import { connect } from 'react-redux';
import Support from 'marketing/common/support';

const mapStateToProps = ({ user: { canChat } }) => {
  return {
    canChat
  };
}

export default connect(mapStateToProps)(Support);
